import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { panelsName } from "../../../panelsTitle";
import updateElementByIdFromArray from "../../../utils/updateElementByIdFromArray";
import { updateGetGpsDatas } from "store/surveyJS";

const hasMapCoordinate = (value: any) =>
  value !== "" &&
  value !== null &&
  value !== undefined &&
  !Number.isNaN(parseFloat(value));

const useHandleMapMovement = (currentQuestionEle: any, map: any) => {
  const [isCenterPointSetup, setIsCenterPointSetup] = useState(false);
  const { getGpsDatas, selectedQuestionElement, surveyActiveTab } = useSelector(
    (state: RootState) => state.surveyJS
  );

  const selectedQuestionType = selectedQuestionElement?.getType();

  const dispatch = useDispatch();

  useEffect(() => {
    if (currentQuestionEle && map && !isCenterPointSetup) {
      const { longitude, latitude } = currentQuestionEle.mapCenterPoint;

      // set map center according to coming data
      if (hasMapCoordinate(longitude) && hasMapCoordinate(latitude)) {
        map.jumpTo({
          center: [parseFloat(longitude), parseFloat(latitude)],
          zoom: currentQuestionEle?.zoomLevel ?? 2,
        });
      }
      // update map center values
      else {
        const syncCurrentMapCenter = () => {
          updateGetGpsDataCenterPoint(
            currentQuestionEle,
            map,
            selectedQuestionType,
            getGpsDatas,
            dispatch
          );
        };

        if (map.loaded()) {
          syncCurrentMapCenter();
        } else {
          map.once("load", syncCurrentMapCenter);
        }
      }

      if (
        selectedQuestionType !== panelsName.HARVEST &&
        selectedQuestionType !== panelsName.GEOGRAPHICAL_INFORMATION
      ) {
        setIsCenterPointSetup(true);
      }
    }
  }, [currentQuestionEle, map, selectedQuestionElement]);

  useEffect(() => {
    if (!currentQuestionEle || !map) {
      return;
    }

    const handleMoveEnd = () => {
      if (surveyActiveTab === "test") {
        return;
      }
      updateGetGpsDataCenterPoint(
        currentQuestionEle,
        map,
        selectedQuestionType,
        getGpsDatas,
        dispatch
      );
    };

    map.on("moveend", handleMoveEnd);

    return () => {
      map.off("moveend", handleMoveEnd);
    };
  }, [
    currentQuestionEle,
    map,
    surveyActiveTab,
    selectedQuestionType,
    getGpsDatas,
    dispatch,
  ]);

  return null;
};

function updateGetGpsDataCenterPoint(
  currentQuestionEle: any,
  map: any,
  selectedQuestionType: any,
  getGpsDatas: any,
  dispatch: any
) {
  const nextLatitude = map.getCenter().lat;
  const nextLongitude = map.getCenter().lng;
  const nextZoomLevel = map.getZoom();

  if (
    currentQuestionEle?.mapCenterPoint?.latitude === nextLatitude &&
    currentQuestionEle?.mapCenterPoint?.longitude === nextLongitude &&
    currentQuestionEle?.zoomLevel === nextZoomLevel
  ) {
    return;
  }

  const updatedCurrentgetGpsDatas = { ...currentQuestionEle };

  // update current element
  updatedCurrentgetGpsDatas.mapCenterPoint = {
    ...updatedCurrentgetGpsDatas.mapCenterPoint,
    latitude: nextLatitude,
    longitude: nextLongitude,
  };
  updatedCurrentgetGpsDatas.zoomLevel = nextZoomLevel;
  if (
    selectedQuestionType !== panelsName.HARVEST &&
    selectedQuestionType !== panelsName.GEOGRAPHICAL_INFORMATION
  ) {
    // update current element state into global elements
    updateElementByIdFromArray(
      getGpsDatas,
      updatedCurrentgetGpsDatas,
      (updatedGetGpsDatas: any) => {
        dispatch(updateGetGpsDatas(updatedGetGpsDatas));
      }
    );
  }
}

export { useHandleMapMovement };
